import React from 'react';

import { InstanceProps, OpenModal } from './Modal';

interface ModalState<P extends InstanceProps<any, any>> extends Pick<P, 'data'> {
  isOpen: boolean;
  resolve: (data: P['data']) => void;
  reject: () => void;
}

export const useModal = <P extends InstanceProps<any, any>>(modal: React.ComponentType<P>) => {
  const [state, setState] = React.useState<ModalState<P>>({} as ModalState<P>);

  return React.useMemo(
    () => ({
      props: {
        isOpen: !!state?.isOpen,
        modal,
        initialFocus: React.createRef<HTMLElement>(),
        data: state?.data,
        onAction: ((data: P['data']) => state?.resolve(data)) as P['onAction'],
        onClose: () => state?.reject()
      },
      open: ((data: Pick<P, 'data'>) => {
        return new Promise((resolve, reject) => {
          setState({ isOpen: true, data, resolve, reject });
        }).finally(() => setState((state) => ({ ...state, isOpen: false })));
      }) as OpenModal<P>
    }),
    [modal, state, setState]
  );
};
